import React,{useState,useEffect} from 'react'
import {Table, Row, Col,Modal,ListGroup} from 'react-bootstrap'
import AdminDashboard from "../../components/AdminDashboard"
import Search from '../../components/assets/search.png'
import Sort from '../../components/assets/filter.png'
import { useSnackbar } from "notistack";
import axios from "axios"

const url = "https://www.bitmasta.io/php/admin_pass.php";
export default function AdminTransactions(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [transacts, setTransacts] = useState([])
    const [loading, setLoading] = useState(true)
    const [status, setStatus] = useState(true)
    const [update, setUpdate] = useState(false)
    const [open, setOpen] = useState(false)
    const [search,setSearch] = useState("")
    const [filter,setFilter] = useState("")
    const [selected,setSelect] = useState("")
    useEffect(()=>{
        const fetchData = async () => {
            let formData = new FormData();
            formData.append("Transact",true)
            try{
           const res = await axios.post(url,formData)
              if(res.data.status === "Transactions Found"){
                setLoading(false)
                setTransacts(res.data.data)
              }
              else{
                setLoading(false)
                setTransacts([])
              }
            }
            catch(err){
            enqueueSnackbar(err, {
              variant: "error",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            })
            }
          }
          fetchData()
        },[enqueueSnackbar,update])
        const handleOpen=(id)=>{
          setOpen(true)
          setSelect(transacts.filter(item=>item.Id === id)[0])
        }
        const handleUpdate = async (id,email)=>{
            setUpdate(!update)
            let formData = new FormData();
            formData.append("Transactions_Id",id)
            formData.append("Transactions_Email",email)
            formData.append("Update_Status",status)
            try{
           const res = await axios.post(url,formData)
              if(res.data.status === "Updated"){
                enqueueSnackbar(res.data.message, {
                    variant: "success",
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "right",
                    },
                  })
              }
            }
            catch(err){
            enqueueSnackbar(err, {
              variant: "error",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            })
        }
        }
    return (
        <AdminDashboard {...props}>
            <div className="d-flex  padding">
                <Col md={7} className="blueBg mr-2">
                    <Row>
                        <Col md={1} className="px-0">
                            <img src={Search} alt=""/>
                        </Col>
                        <Col md={8} className="px-0">
                            <input type="search" 
                                   placeholder="email" 
                                   className="w100"
                                   value={search}
                                   onChange={e=>setSearch(e.target.value)}
                            />
                        </Col>
                        <Col md={3} className="px-0">
                            <button className="w-100 search-button">
                                Search
                            </button>
                        </Col>
                    </Row>
                </Col>
                {/* <Col md={1}></Col> */}
                <Col md={5} className="blueBg">
                    <Row>
                        <Col md={2} className="px-0">
                            <img src={Sort} alt=""/>
                        </Col>
                        <Col md={10} className="px-0">
                            <select value={filter} onChange={e=>setFilter(e.target.value)} className="w-100 trans-select">
                                <option value="">Transaction Type</option>
                                <option value="Buy">Buy</option>
                                <option value="Sell">Sell</option>
                            </select>
                        </Col>
                    </Row>
                </Col>
            </div>
            <Table responsive>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Email</th>
                        <th>Transaction</th>
                        <th>Amount</th>
                        <th>Acc. Details</th>
                        {/* <th>Receipt</th> */}
                        <th>Status</th>
                        <th>Update Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                !loading ?
                  transacts.length > 0 ?
                    transacts.filter((trans)=>(search === "" || trans.Email.toLowerCase().includes(search.toLowerCase()))&&(filter === "" || trans.Type.includes(filter))).map((trans,i)=>(
                      <tr key={i}>
                        <td>{trans.Date}</td>
                        <td>{trans.Email}</td>
                        <td className={`b7 ${trans.Type === "Buy" ?"buy":"sell"}`}>{trans.Type}</td>
                        <td>{trans.Amount_In_Crypto}</td>
                        <td>
                    {trans.Type === "Sell" ?<button className="update-button" onClick={()=>handleOpen(trans.Id)}>open</button>: null}</td>
                        {/* <td>{trans.Has_File && <a href="https://www.bitmasta.io/php" target="_blank" rel="noopener noreferrer" className="receipt">View receipt</a>}</td> */}

                        <td>{trans.Status}</td>
                        <td>
                            <select onChange={(e)=>setStatus(e.target.value)} className="update-status">
                                <option value="">Set Status</option>
                                <option value="Pending">Pending</option>
                                <option value="Uncompleted">Uncompleted</option>
                                <option value="Completed">Completed</option>
                            </select>
                        </td>
                        <td>
                            <button className="update-button" onClick={()=>handleUpdate(trans.Id,trans.Email)}>Update</button>
                        </td>
                    </tr>
                    ))
                  : <tr>
                 <td> No Transaction Found</td>
                </tr>
                : 
                <tr>
                 <td> Loading...</td>
                </tr>
              }
                </tbody>
            </Table>
            <Modal show={open} onHide={()=>setOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Account Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <ListGroup>
        <ListGroup.Item>
            <p className="m-0">User:</p>
            <span className="text-muted">{selected.Email}</span>
          </ListGroup.Item>
          <ListGroup.Item>
            <p className="m-0">Bank Name</p>
            <span className="text-muted">{selected.Bank_Name}</span>
          </ListGroup.Item>
          <ListGroup.Item>
          <p className="m-0">Account Name</p>
            <span className="text-muted">{selected.Account_Name}</span>
          </ListGroup.Item>
          <ListGroup.Item>
          <p className="m-0">Account Number</p>
          <span className="text-muted">{selected.Account_Number}</span>
          </ListGroup.Item>
        </ListGroup>
        </Modal.Body>
        
      </Modal>
        </AdminDashboard>
    )
}
